import type { Route } from 'vue-router'
import type { Store } from 'vuex'

import type { AppConfig, GuardResolveFunction } from '../models'
import { CONTAINER } from '../config'

import { TYPES } from '../config/inversify.types'
import { GuardClass } from '../models'

import { ROUTER_CONSTS } from '../router/router.consts'

import { ANALYTICS_CONSTS } from '../store/analytics/analytics.consts'
import { AUDIT_CONSTS } from '../store/audit/audit.consts'
import { AUTH_CONSTS } from '../store/auth/auth.consts'
import { COMMON_CONSTS } from '../store/common/common.consts'
import { CONFIG_CONSTS } from '../store/config/config.consts'
import { CONTEXT_CONSTS } from '../store/context/context.consts'
import { CRUD_CONSTS } from '../store/crud/crud.consts'
import { INSTANCE_MANAGEMENT_CONSTS } from '../store/instance-management/instance-management.consts'
import { OIDC_CONSTS } from '../store/oidc/oidc.consts'
import { SEARCH_CONSTS } from '../store/search/search.consts'
import { TOOLING_CONSTS } from '../store/tooling/tooling.consts'

export class LogoutGuard extends GuardClass {
  static async execute(
    this: void,
    to: Route,
    from: Route,
    next: GuardResolveFunction,
  ): Promise<void> {
    const store: Store<any> = CONTAINER.get<Store<any>>(TYPES.Store)
    const { oidcLogin, oidcLogout } = CONTAINER.get<AppConfig>(TYPES.AppConfig)

    await store.dispatch(`${AUTH_CONSTS.moduleName}/${AUTH_CONSTS.actions.logout}`)

    await Promise.all(
      [
        CONFIG_CONSTS,
        CONTEXT_CONSTS,
        ANALYTICS_CONSTS,
        CRUD_CONSTS,
        TOOLING_CONSTS,
        SEARCH_CONSTS,
        AUDIT_CONSTS,
        INSTANCE_MANAGEMENT_CONSTS,
      ].reduce((resetDispatches: Promise<any>[], moduleConsts: Record<string, any>) => {
        const moduleName = moduleConsts.moduleName as string
        if (
          Object.keys(store.getters as Record<string, any>).some((getterKey: string) =>
            getterKey.includes(`${moduleName}/`),
          )
        ) {
          resetDispatches.push(store.dispatch(`${moduleName}/${COMMON_CONSTS.actions.reset}`))
        }
        return resetDispatches
      }, []),
    )

    if (oidcLogin) {
      const oidcLogoutAction = oidcLogout
        ? OIDC_CONSTS.actions.signOutOidc
        : OIDC_CONSTS.actions.removeOidcUser
      await store.dispatch(`${OIDC_CONSTS.moduleName}/${oidcLogoutAction}`)
    }

    next({
      ...to,
      name: ROUTER_CONSTS.routes.login,
      replace: true,
    })
  }
}
